"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const excavator_types_1 = require("./excavator.types");
const contractor_1 = require("services/master-data/contractor");
const excavator_1 = require("services/master-data/excavator");
const getDataGrid = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, excavator_1._getMasterExcavator)(dataStates);
    if (response.isError) {
        dispatch({
            type: excavator_types_1.excavatorTypes.SET_ERROR, payload: {
                isError: response.isError,
                errorCode: response.errorCode, errorMessage: response.errorMessage
            }
        });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date), status: item.is_active ? 'Active' : 'Inactive' });
            })
        };
        dispatch({ type: excavator_types_1.excavatorTypes.SET_DATA_GRID, payload });
    }
});
const onDataStateChange = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = {
        dataStates
    };
    dispatch({ type: excavator_types_1.excavatorTypes.ON_PAGE_CHANGE, payload });
});
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: excavator_types_1.excavatorTypes.ON_MUTATION_CLICK, payload });
};
const closeError = () => dispatch => {
    dispatch({
        type: excavator_types_1.excavatorTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false
        }
    });
};
const onSaveDataItem = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { mutationMode } = payload;
    const response = payload.mutationMode == 'add' ?
        yield (0, excavator_1._createExcavator)({
            contractor_id: (_b = (_a = payload.dataItem) === null || _a === void 0 ? void 0 : _a.contractor) === null || _b === void 0 ? void 0 : _b.id,
            excavator_no: (_c = payload.dataItem) === null || _c === void 0 ? void 0 : _c.excavator_no.replace('Ex-', ''),
            excavator_capacity: payload.dataItem.excavator_capacity,
            excavator_spec: payload.dataItem.excavator_spec,
            is_active: (_e = (_d = payload.dataItem) === null || _d === void 0 ? void 0 : _d.is_active) === null || _e === void 0 ? void 0 : _e.value,
            modified_by: payload.dataItem.modified_by
        }) :
        yield (0, excavator_1._editExcavator)({
            id: payload.dataItem.id,
            contractor_id: (_g = (_f = payload.dataItem) === null || _f === void 0 ? void 0 : _f.contractor) === null || _g === void 0 ? void 0 : _g.id,
            excavator_no: (_h = payload.dataItem) === null || _h === void 0 ? void 0 : _h.excavator_no.replace('Ex-', ''),
            excavator_capacity: payload.dataItem.excavator_capacity,
            excavator_spec: payload.dataItem.excavator_spec,
            is_active: (_k = (_j = payload.dataItem) === null || _j === void 0 ? void 0 : _j.is_active) === null || _k === void 0 ? void 0 : _k.value,
            modified_date: new Date(),
            modified_by: payload.dataItem.modified_by
        });
    const dataItem = Object.assign(Object.assign({}, payload.dataItem), { id: response.data.id });
    const isSuccess = !response.isError;
    if (isSuccess)
        dispatch({ type: excavator_types_1.excavatorTypes.ON_SAVE_DATAITEM, payload: Object.assign(Object.assign({}, payload), { dataItem, mutationMode, isSuccess }) });
    else
        dispatch({
            type: excavator_types_1.excavatorTypes.SET_ERROR, payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage })
        });
});
const onDelete = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, excavator_1._deleteExcavator)({ id: payload.dataItem.id });
    const isSuccess = !response.isError;
    if (isSuccess)
        dispatch({ type: excavator_types_1.excavatorTypes.ON_DELETE, payload: Object.assign(Object.assign({}, payload), { isSuccess }) });
    else
        dispatch({
            type: excavator_types_1.excavatorTypes.SET_ERROR, payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage })
        });
});
const getDetail = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, contractor_1._getDropdownMasterContractorCoalMining)();
    const dataContractor = response.data;
    dispatch({ type: excavator_types_1.excavatorTypes.GET_DETAIL, payload: dataContractor });
});
const onFilterChange = (payload) => dispatch => {
    dispatch({ type: excavator_types_1.excavatorTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = payload => dispatch => {
    dispatch({ type: excavator_types_1.excavatorTypes.ON_SORT_CHANGE, payload });
};
exports.default = {
    onDataStateChange,
    onClickMutation,
    onSaveDataItem,
    getDetail,
    onDelete,
    getDataGrid,
    onFilterChange,
    onSortChange,
    closeError
};
